module.exports = __webpack_public_path__ + "static/media/ivoox.1aba4255.jpg";